import { render, staticRenderFns } from "./MonitoramentoDropdown.vue?vue&type=template&id=588838ce&scoped=true&"
import script from "./MonitoramentoDropdown.vue?vue&type=script&lang=js&"
export * from "./MonitoramentoDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MonitoramentoDropdown.vue?vue&type=style&index=0&id=588838ce&prod&scoped=true&lang=css&"
import style1 from "./MonitoramentoDropdown.vue?vue&type=style&index=1&id=588838ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588838ce",
  null
  
)

export default component.exports